import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getPercentageinterests,
  percentageinterestsListSuccessful,
  percentageinterestsAddSuccessful,
  isModelVisible,
} from "./percentageinterestsSlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* getPercentageinterest({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/percentageinterests/", data);
    yield put(percentageinterestsListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddPercentageinterests({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/percentageinterests/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Interest Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getPercentageinterests({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Interest. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(percentageinterestsAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/percentageinterests/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Interest Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getPercentageinterests({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Interest. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(percentageinterestsAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeletePercentageinterests({ payload }) {
  var countryID = payload;
  try {
    const response = yield call(postDelete, "/masters/percentageinterests/" + countryID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Interest Edited Successfully.!
            </p>
          </div>
        ),
      });
      yield put(getPercentageinterests({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Unable to edit Interest. Please try again!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchgetPercentageinterests() {
  yield takeEvery("percentageinterests/getPercentageinterests", getPercentageinterest);
}
export function* watchPercentageinterestsAdd() {
  yield takeEvery("percentageinterests/percentageinterestsAdd", AddPercentageinterests);
}

export function* watchPercentageinterestsDelete() {
  yield takeEvery("percentageinterests/percentageinterestsDelete", DeletePercentageinterests);
}

function* PercentageinterestsSaga() {
  yield all([fork(watchgetPercentageinterests), fork(watchPercentageinterestsAdd), fork(watchPercentageinterestsDelete)]);
}

export default PercentageinterestsSaga;
